/**
 * Name of the cookie that stores the CSRF token.
 *
 * The token is set by the server as a same-origin cookie and must be echoed
 * back in a request header so the server can verify that the request
 * originated from a page it served (preventing cross-site request forgery).
 */
export const CSRF_COOKIE_NAME = 'csrftoken';

/**
 * HTTP header used to send the CSRF token back to the server.
 */
export const CSRF_HEADER_NAME = 'X-CSRFToken';
